import React from 'react'
import { Avatar } from '@ztechapps/webui.util'

export const EmptyMembers = () => {
  return (
    <Avatar
      src={'https://res.cloudinary.com/tmmshauler/image/upload/v1644071385/common-for-all/add-user.png'}
      name={'Add member'}
    />
  )
}
